import { useTexture } from '@react-three/drei'

export default function EasterEggs()
{
    const texture = useTexture('./textures/eastereggs/quake3arena.png')

    return <>


        {/* BOTTOM */}
        <mesh  
            position={[ -0.5, -3.01, -0.5 ]} 
            rotation-x={ Math.PI * 0.5 }  
            rotation-z={ - Math.PI * 0.5 }
        >
            <planeGeometry  
                args={[2,2]} 
            />
            <meshStandardMaterial 
                map={texture} 
                transparent={true}
            />
        </mesh>
        
    </>   
}